import itemSizes from "constants/sizes";

export default class DimensionHelper{
  constructor({heightAndTimeArray, clientHeight, happyPlaceDistanceType = 'medium'}){
    this.setDimensions({heightAndTimeArray, clientHeight, happyPlaceDistanceType})
  }

  setDimensions({heightAndTimeArray, clientHeight, happyPlaceDistanceType}){
    this.heightAndTimeArray = heightAndTimeArray
    this.lastItemHeight = this.getLastItemHeight()
    this.lastItemSize = this.getLastItemSize()
    this.clientHeight = clientHeight
    this.happyPlaceDistanceType = happyPlaceDistanceType
    this.cursorHappyPlace = this.getCursorHappyPlace()
    this.scrollGutterHeight = this.getScrollGutterHeight()
    this.maxScrollTop = this.getMaxScrollTop()
  }
  
  updateHeightAndTimeArray(heightAndTimeArray){
    this.heightAndTimeArray = heightAndTimeArray
    this.lastItemHeight = this.getLastItemHeight()
    this.lastItemSize = this.getLastItemSize()
    if(this.happyPlaceDistanceType === 'short'){
      this.cursorHappyPlace = this.getCursorHappyPlace()
    }
    this.scrollGutterHeight = this.getScrollGutterHeight()
    this.maxScrollTop = this.getMaxScrollTop()
  }

  updateHPDistanceType(happyPlaceDistanceType){
    this.happyPlaceDistanceType = happyPlaceDistanceType
  }

  updateClientHeight(clientHeight){
    this.clientHeight = clientHeight
    this.cursorHappyPlace = this.getCursorHappyPlace()
    this.scrollGutterHeight = this.getScrollGutterHeight()
    this.maxScrollTop = this.getMaxScrollTop()
  }

  getLastItemHeight() { 
      const hat =  this.heightAndTimeArray || [];
      if (hat.length > 0) {
        return hat[hat.length - 1].height;
      } else {
        return 0;
      }
  }

  getCursorHappyPlace() {
      if (this.happyPlaceDistanceType === "short") {
        return Number.parseInt(itemSizes.smallHeadingHeight * 4);
      } else {
        return this.clientHeight / 3.5;
      }
  }

  getLastItemSize() {
      const length = this.heightAndTimeArray.length;
      if (length === 0) {
        return 0;
      } else if (length === 1) {
        return this.heightAndTimeArray[0].height;
      } else {
        return (
          this.heightAndTimeArray[length - 1].height -
          this.heightAndTimeArray[length - 2].height
        );
      }
  }

  getMaxScrollTop() {
      const mst = this.lastItemHeight - this.cursorHappyPlace;
      if (mst < 0) {
        return this.lastItemHeight - this.lastItemSize - 2;
      } else {
        return mst;
      }
  }

  getScrollGutterHeight() {
    if (this.cursorHappyPlace < this.lastItemHeight) {
      return this.clientHeight - this.cursorHappyPlace;
    } else {
      return (
        this.clientHeight -
        this.lastItemHeight -
        2 +
        this.lastItemSize / 2
      );
    }
  }

  calcSpaceByCursorTop({newCursorTop}) {
      if (newCursorTop - this.cursorHappyPlace * 2 > 0) {
          return this.cursorHappyPlace;
      } else {
          const progress = newCursorTop / (this.cursorHappyPlace * 2);
          return progress * this.cursorHappyPlace;
      } 
  }

  calcSpaceByScrollTop({latestScrollTop}) {
    const gap = this.cursorHappyPlace - this.maxScrollTop;
    if (gap > 0) {
      const progress = latestScrollTop / this.maxScrollTop;
      return latestScrollTop + gap * progress;
    } else if (latestScrollTop < this.cursorHappyPlace) {
      return latestScrollTop;
    } else {
      return this.cursorHappyPlace;
    }
  }

}
